<section id="content" *ngIf="lang">
  <div class="page page-profile">

    <!-- page header -->
    <div class="pageheader">
      <h2>{{ lang.notification }}</h2>
      <div class="page-bar">
        <ul class="page-breadcrumb">
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.DASHBOARD"><i class="fa fa-home"></i>
              {{AppSettings.SITE_TITLE | titlecase}}</a>
          </li>
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.Notification_List">{{ lang.humanResources }}</a>
          </li>
          <li>
            <a>{{ records.subject }}</a>
          </li>
        </ul>


        <div style="float: right;">
          <div class="social-icons">
            <a class="plus-edit"  (click)="edit(this.id)" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
              <i class="fa fa-edit"></i>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- page content -->
    <div class="pagecontent">

      <!-- row -->
      <div class="row">
        <div class="col-md-12">
          <div class="tile tile-simple">

            <!-- tile body -->
            <div class="tile-body" [ngSwitch]="pageView">
              <div role="tabpanel" *ngSwitchCase="'list'">


                <div class="tab-content">

                  <div class="panel panel-default">
                    <div class="panel-heading1">View

                    </div>

                    <div class="panel-body">
                      <div class="table-responsive">
                        <table class="table table-striped table-bordered" id="table1">

                          <tbody>
                            <tr>
                              <td>Category Type</td>
                              <td>{{ records.cat_type }}</td>
                            </tr>
                            <tr>
                              <td>Subject</td>
                              <td>{{ records.subject }}</td>
                            </tr>
                            <tr>
                              <td>Text</td>
                              <td>{{ records.disp }}</td> 
                            </tr>
                            <tr>
                              <td>Notes</td>
                              <td>{{ records.notes }}</td>
                            </tr>
                            <tr>
                              <td>Creation Date</td>
                              <td>{{ records.noti_date }}</td>
                            </tr>
                            <tr>
                              <td>Attachments</td>
                              <td><a
                                  href="http://vmi313621.contaboserver.net/Software_backend/uploads/course_material/notification/{{records.attachment}}"
                                  target="_blank">{{ records.attachment }}</a></td>
                            </tr>
                          </tbody>

                        </table>
                      </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading1">LIST OF RECIPIENTS</div>
                    <div class="panel-body">
                      <div class="table-responsive">
                        <table class="table-striped table-sm row-border hover" id="table1">
                          <thead>
                            <tr>
                              <th>Name</th>
                              <th>Surname</th>
                              <th>Task</th>
                              <th>Email</th>
                              <th>Fiscal Code</th>
                              <th>Distribustion Status</th>
                              <th>Date Of Sent</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let emprecord of emprecords let i = index" id="{{emprecord.id}}">
                              <td>{{ emprecord.employee_name }}</td>
                              <td>{{ emprecord.employee_surname }}</td>
                              <td>{{ emprecord.employee_task }}</td>
                              <td>{{ emprecord.employee_email }}</td>
                              <td>{{ emprecord.employee_tax_code }}</td>
                              <td>
                                <div *ngIf="emprecord.relation_num; then thenBlock else elseBlock"></div>

                                <ng-template #thenBlock><span style="color:green;"><i class="fa fa-circle"
                                      aria-hidden="true"></i></span></ng-template>

                                <ng-template #elseBlock><span style="color:red;"><i class="fa fa-circle"
                                      aria-hidden="true"></i></span></ng-template>


                              </td>
                              <td>{{ emprecord.send_date }}</td>
                              <td>
                                <div class="btn-group dropup">

                                  <button type="button" class="btn btn-info dropdown-toggle circle_btn"
                                    data-toggle="dropdown" aria-expanded="false"><i class="fa fa-tasks"></i></button>

                                  <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">
                                    <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                        class="delete_action"
                                        (click)="delete(records.emp_id,records.id,emprecord.employeeId)"><i
                                          class="fa fa-trash"></i> {{ lang.erase }}</a></li>
                                    <li><a (click)="sent_mails(emprecord.employeeId,emprecord.employee_email,records.subject, emprecord.sender)"
                                        class="blue_action"><i class="glyphicon glyphicon-envelope"></i>Mail</a>
                                    </li>
                                  </ul>
                                </div>
                              </td>
                            </tr>
                          </tbody>

                        </table>


                    <form [formGroup]="createForm" (ngSubmit)="onSubmit()" class="form-validation">
                      <div class="form-group">
                        <div class="col-md-4">
                          <ng-multiselect-dropdown formControlName="emp_details" [data]="add_empdetails"
                            [settings]="dropdownSettings">
                          </ng-multiselect-dropdown>
                        </div>
                        <input type="hidden" name="noti_id" value="{{ records.id }}">
                        <div class="col-md-4">
                          <input type="submit" name="submit" value="Add people" class="btn btn-purple">
                        </div>
                      </div>
                    </form>

                    
                      </div>
                    </div>


                  </div>



                 


                </div>


              </div>


          

            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</section>

